import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme, type ThemePreference } from "@/hooks/useTheme";

const OPTIONS: { id: ThemePreference; label: string; icon: typeof Sun; hint?: string }[] = [
  { id: "light", label: "Light", icon: Sun },
  { id: "dark", label: "Dark", icon: Moon },
  { id: "system", label: "System", icon: Monitor, hint: "Follow browser / OS" },
];

/** Segmented Light / Dark / System control for Preferences. */
export function ThemePreferenceSelect() {
  const { preference, setPreference } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="inline-flex shrink-0 rounded-[10px] border border-[var(--border)] p-0.5"
    >
      {OPTIONS.map(({ id, label, icon: Icon, hint }) => {
        const active = preference === id;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={active}
            title={hint || label}
            className={`inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-sm transition-colors ${
              active
                ? "bg-[var(--bg-hover)] font-medium text-[var(--text-primary)]"
                : "text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
            }`}
            onClick={() => setPreference(id)}
          >
            <Icon size={14} />
            {label}
          </button>
        );
      })}
    </div>
  );
}
